import { render, staticRenderFns } from "./StatesMachinePage.vue?vue&type=template&id=2cd89f00&scoped=true"
import script from "./StatesMachinePage.vue?vue&type=script&lang=js"
export * from "./StatesMachinePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd89f00",
  null
  
)

export default component.exports